import { render, staticRenderFns } from "./AppAddToHomeScreen.vue?vue&type=template&id=796230d2&"
import script from "./AppAddToHomeScreen.vue?vue&type=script&lang=js&"
export * from "./AppAddToHomeScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports